module.exports = __webpack_public_path__ + "static/media/journal.f2b7ee42.png";